// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "hashed-1/" + (chunkId === 66586 ? "griffel" : chunkId) + "-" + {"60891":"e6aaf522e5","66586":"e6fc2b8ec6"}[chunkId] + ".css";
};